import React, { useState } from "react";
import { FaFileCsv, FaPlus } from "react-icons/fa";
import "./RequestPanel.css";

const RequestPanel = () => {
  const [selectedRange, setSelectedRange] = useState("30");

  return (
    <div className="requests-container">
      <h3>Requests</h3>

      <div className="filters-header">
        <div className="input-group">
          <input type="text" placeholder="Search Client Name" />
          <input type="text" placeholder="Search Client File #" />
          <select>
            <option>Status</option>
          </select>
          <select>
            <option>Staff Name</option>
          </select>
          <input type="text" placeholder="Search Provider Name" />
        </div>

        <div className="button-group">
          <button className="btn purple">
            <FaFileCsv /> Export as CSV
          </button>
          <button className="btn disabled">Reassign Staff</button>
          <button className="btn purple">
            <FaPlus /> Create Request
          </button>
        </div>
      </div>

      <div className="date-filter">
        <span className="blue">Date Range</span>
        <label>
          <input
            type="radio"
            checked={selectedRange === "30"}
            onChange={() => setSelectedRange("30")}
          />{" "}
          Last 30 Days
        </label>
        <label>
          <input
            type="radio"
            checked={selectedRange === "60"}
            onChange={() => setSelectedRange("60")}
          />{" "}
          Last 60 Days
        </label>
        <label>
          <input
            type="radio"
            checked={selectedRange === "90"}
            onChange={() => setSelectedRange("90")}
          />{" "}
          Last 90 Days
        </label>
        <span className="blue reset">Reset</span>
      </div>

      <div className="request-table-wrapper">
        <table className="request-table">
          <thead>
            <tr>
              <th>
                <input type="checkbox" />
              </th>
              <th>Client</th>
              <th>Request Type</th>
              <th>Request ID</th>
              <th>Request Date</th>
              <th>Label</th>
              <th>Client File #</th>
              <th>Staff Assigned</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" className="no-data">
                There is no data to display
              </td>
            </tr>
          </tbody>
        </table>
        <div className="pagination">10 ▾</div>
      </div>
    </div>
  );
};

export default RequestPanel;
